'use client';
import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';


import Link from '@eliadmin/core/src/components/link';
import Image from '@eliadmin/core/src/components/image/image-wrapped';

import { Button } from '@eliadmin/core/src/components/ui/button';
import { Container } from '@eliadmin/core/src/components/ui/container';

import { cn } from '@eliadmin/core/src/utils/style-utils';

import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import { Navigation, Pagination, Mousewheel, Keyboard } from 'swiper/modules';

import type { Reference } from '@eliadmin/core/src/api/references/references-types';

interface CustomGalleryProps {
  references: Reference[];
  title?: string;
  buttonLabel?: string;
  cardHover?: string;
  description?: string;
  locale: string;
}

const urlMap: { [key: string]: string } = {
  sk: 'referencie',
  en: 'references',
  it: 'riferimenti',
  de: 'referenzen',
};

export const CustomGallery = ({
  references,
  title,
  description,
  buttonLabel,
  cardHover,
  locale,
}: CustomGalleryProps) => {
  const aboutLink = `/${urlMap[locale] || urlMap['sk']}`;

  return (
    <Container size="xl" className={cn('', 'ea-custom-gallery__container')}>
      <div className="space-y-2">
        <div className="mx-auto h-[2px] w-16 bg-primary" />
        <h2 className="decorated-font text-center text-3xl font-medium text-background">{title}</h2>
        {description && <p className={cn('', 'ea-custom-gallery__description')}>{description}</p>}
      </div>
      <Swiper
        cssMode={true}
        navigation={true}
        pagination={true}
        mousewheel={true}
        keyboard={true}
        modules={[Navigation, Pagination, Mousewheel, Keyboard]}
        slidesPerView={'auto'}
        spaceBetween={16}
        className={cn('', 'mySwiper ea-custom-gallery__swiper')}
      >
        {references?.map(reference => {
          return (
            <SwiperSlide
              key={reference?.id ?? reference?.slug ?? reference?.name}
              className={cn('', 'ea-custom-gallery__slide group transition')}
            >
              <div className={cn('', 'ea-custom-gallery__slide-overlay')} />
              <Image
                src={reference?.image?.url ?? '/images/placeholder.png'}
                alt={resolveImageAlt(reference?.image, reference?.name, reference?.name ?? '')}
                fill
                style={{ objectFit: 'cover', objectPosition: 'center' }}
                className="z-[1]"
              />
              <Button asChild className={cn('', 'ea-custom-gallery__hover-button')}>
                <Link href={reference?.slug ? `/referencie/${reference.slug}` : '#'}>
                  {cardHover}
                </Link>
              </Button>
            </SwiperSlide>
          );
        })}
      </Swiper>
      <Button asChild variant={'outline'} className={cn('', 'ea-custom-gallery__show-more-button')}>
        <Link href={aboutLink}>{buttonLabel}</Link>
      </Button>
    </Container>
  );
};
